<div *ngIf="mode === 'valuationProject'">
  <h3 class="dxs-history-title">{{ 'projectValuationAttachments.portfolioAttachments' | translate | uppercase }}</h3>
  <div class="attachmentList portfolio" *ngIf="attachmentList?.valuationPortfolioFileAttachment && attachmentList?.valuationPortfolioFileAttachment.length > 0">
    <div class="attachmentListFile" *ngFor="let file of attachmentList?.valuationPortfolioFileAttachment; index as i;" (click)="openAttachment(file, 'valuationProject')">
      <div *ngIf="file?.fileTypeId == 1">
        <div class="attachmentList-file-content">
          <div class="attachmentList-file-icon ">
            <span class="k-icon k-i-pdf" style="font-size: 30px;"></span>
          </div>
          <div class="attachmentList-file-fileTypeDescription">{{ file.fileTypeDescription}}</div>
          <div class="attachmentList-file-created">{{ file.created | date:'dd.MM.yyyy H:mm:ss' }}</div>
        </div>
        <div class="attachmentList-file-name" title="{{file.fileName}}">{{file.fileName}}</div>
      </div>
      <div *ngIf="file?.fileTypeId != 1">
        <div class="attachmentList-file-content">
          <div class="attachmentList-file-icon">
            <span class="k-icon k-i-file-ppt" style="font-size: 30px;"></span>
          </div>
          <div class="attachmentList-file-fileTypeDescription">{{ file.fileTypeDescription}}</div>
          <div class="attachmentList-file-created">{{ file.created | date:'dd.MM.yyyy H:mm:ss' }}</div>
        </div>
        <div class="attachmentList-file-name" title="{{file.fileName}}">{{file.fileName}}</div>
      </div>
    </div>
  </div>
  <div class="attachmentListNoFiles portfolio" *ngIf="attachmentList?.valuationPortfolioFileAttachment && attachmentList?.valuationPortfolioFileAttachment.length < 1">
    <h4 class="dxs-history-title" style="margin-top: 10px;">{{ 'projectValuationAttachments.noAttachments' | translate | uppercase }}</h4>
  </div>
</div>

<div class="panelbar-wrapper" *ngIf="mode === 'report'">
  <kendo-panelbar class="panelbar">
    <kendo-panelbar-item title="{{ 'projectValuationAttachments.reportAttachments' | translate | uppercase }}">
      <ng-template kendoPanelBarContent>
        <div style="padding: 10px;">
          <div>
            <div class="attachmentList" *ngIf="attachmentList?.propertyFileAttachment && attachmentList?.propertyFileAttachment.length">
              <div class="attachmentListFile" *ngFor="let file of attachmentList?.propertyFileAttachment; index as i;" (click)="openAttachment(file, 'report')">
                <div *ngIf="file.fileTypeId == 1">
                  <div class="attachmentList-file-content">
                    <div class="attachmentList-file-icon ">
                      <span class="k-icon k-i-pdf" style="font-size: 30px;"></span>
                    </div>
                    <div class="attachmentList-file-fileTypeDescription">{{ file.fileTypeDescription}}</div>
                    <div class="attachmentList-file-created">{{ file.created | date:'dd.MM.yyyy H:mm:ss' }}</div>
                  </div>
                  <div class="attachmentList-file-name" title="{{file.fileName}}">{{file.fileName}}</div>
                </div>
                <div *ngIf="file.fileTypeId != 1">
                  <div class="attachmentList-file-content">
                    <div class="attachmentList-file-icon">
                      <span class="k-icon k-i-file-ppt" style="font-size: 30px;"></span>
                    </div>
                    <div class="attachmentList-file-fileTypeDescription">{{ file?.fileTypeDescription}}</div>
                    <div class="attachmentList-file-created">{{ file.created | date:'dd.MM.yyyy H:mm:ss' }}</div>
                  </div>
                  <div class="attachmentList-file-name" title="{{file.fileName}}">{{file?.fileName}}</div>
                </div>
              </div>
            </div>
            <div class="attachmentListNoFiles" *ngIf="!attachmentList.propertyFileAttachment || attachmentList.propertyFileAttachment.length < 1">
              <h4 class="dxs-history-title" style="margin-top: 10px;">{{ 'projectValuationAttachments.noAttachments' | translate | uppercase }}</h4>
            </div>
          </div>
        </div>
      </ng-template>
    </kendo-panelbar-item>
    <kendo-panelbar-item title="{{ 'projectValuationAttachments.portfolioAttachments' | translate | uppercase }}">
      <div style="padding: 10px;">
        <div>
          <div class="attachmentList" *ngIf="attachmentList?.valuationPortfolioFileAttachment && attachmentList?.valuationPortfolioFileAttachment.length > 0">
            <div class="attachmentListFile" *ngFor="let file of attachmentList?.valuationPortfolioFileAttachment; index as i;" (click)="openAttachment(file, 'valuationProject')">
              <div *ngIf="file.fileTypeId == 1">
                <div class="attachmentList-file-content">
                  <div class="attachmentList-file-icon ">
                    <span class="k-icon k-i-pdf" style="font-size: 30px;"></span>
                  </div>
                  <div class="attachmentList-file-fileTypeDescription">{{ file.fileTypeDescription}}</div>
                  <div class="attachmentList-file-created">{{ file.created | date:'dd.MM.yyyy H:mm:ss' }}</div>
                </div>
                <div class="attachmentList-file-name" title="{{file.fileName}}">{{file.fileName}}</div>
              </div>
              <div *ngIf="file.fileTypeId != 1">
                <div class="attachmentList-file-content">
                  <div class="attachmentList-file-icon">
                    <span class="k-icon k-i-file-ppt" style="font-size: 30px;"></span>
                  </div>
                  <div class="attachmentList-file-fileTypeDescription">{{ file.fileTypeDescription}}</div>
                  <div class="attachmentList-file-created">{{ file.created | date:'dd.MM.yyyy H:mm:ss' }}</div>
                </div>
                <div class="attachmentList-file-name" title="{{file.fileName}}">{{file.fileName}}</div>
              </div>
            </div>
          </div>
          <div class="attachmentListNoFiles" *ngIf="!attachmentList.valuationPortfolioFileAttachment || attachmentList.valuationPortfolioFileAttachment.length < 1">
            <h4 class="dxs-history-title" style="margin-top: 10px;">{{ 'projectValuationAttachments.noAttachments' | translate | uppercase }}</h4>
          </div>
        </div>
      </div>
    </kendo-panelbar-item>
  </kendo-panelbar>
</div>
